import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { Sizes } from "./constants";
import { ActiveSprintProps } from "./types";

export const details = {
  name: "JiraActiveSprint",
  description: "Displays the active sprint for a Jira board",
  tags: ["Business", "Productivity", "Organization"],
  category: "Jira",
  grid: Sizes,
  gridNames: {
    default: "Medium",
    large: "Large",
  },
  integrationsUsed: ["atlassian"],
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  defaultProps: {},
} as ElementDetails<ActiveSprintProps>;
